import type { components } from '../../../generated/fct';
import { ApiError, ApiRequest } from '../../shared';

export type CwfDocumentStatus = components['schemas']['DocumentStatusEnum'];

export const CWF_DOCUMENT_STATUS = {
  CLINICAL_QA_PASSED: 'CLINICAL_QA_PASSED',
  DRAFT: 'DRAFT',
  DRAFT_READY: 'DRAFT_READY',
  INITIAL_CHECK: 'INITIAL_CHECK',
  INTERNAL_QC: 'INTERNAL_QC',
  INTERNAL_REJECTED: 'INTERNAL_REJECTED',
  PENDING_QC: 'PENDING_QC',
  PUBLISHED: 'PUBLISHED',
  QC_APPROVED: 'QC_APPROVED',
  QC_REJECTED: 'QC_REJECTED',
  RAD_APPROVED: 'RAD_APPROVED',
  RAD_BYPASS_QC: 'RAD_BYPASS_QC',
  RAD_REJECTED: 'RAD_REJECTED',
  REJECTED: 'REJECTED',
  UNPUBLISHED: 'UNPUBLISHED',
} as const satisfies Record<string, CwfDocumentStatus>;

type BaseCwfActiveDocument = Pick<
  components['schemas']['Document'],
  'name' | 'patientId' | 'status' | 'typeId' | 'uuid'
>;

export type CwfActiveDocument =
  | ({ careActivityId: null; carePlanId: null; studyId: string } & BaseCwfActiveDocument)
  | ({ careActivityId: string; carePlanId: string; studyId: null } & BaseCwfActiveDocument);

export interface CwfActiveDocumentsParams {
  patient_id: string;
  status: CwfDocumentStatus;
  study_id: string;
  type_id: string;
}

export interface CwfActiveDocumentsPayload {
  params: Partial<CwfActiveDocumentsParams>;
}

export type CwfActiveDocumentsRequest = ApiRequest<CwfActiveDocumentsPayload>;

export type CwfActiveDocumentsResponse = CwfActiveDocument[];

export type CwfActiveDocumentsError = ApiError<unknown>;

export type CwfActiveDocumentByType = components['schemas']['DocumentWithContent'] & {
  studyId: string;
};

export interface CwfActiveDocumentByTypePayload {
  study_id: string;
  type_id: string;
}

export type CwfActiveDocumentByTypeRequest = ApiRequest<CwfActiveDocumentByTypePayload>;

export type CwfActiveDocumentByTypeResponse = CwfActiveDocumentByType;

export type CwfActiveDocumentByTypeError = ApiError<unknown>;

export type CwfActiveDocumentByCarePlan = Omit<
  components['schemas']['DocumentWithContent'],
  'studyId'
> & {
  careActivityId: string;
  carePlanId: string;
};

export interface CwfActiveDocumentByCarePlanPayload {
  care_activity_id: string;
  care_plan_id: string;
  type_id: string;
}

export type CwfActiveDocumentByCarePlanRequest = ApiRequest<CwfActiveDocumentByCarePlanPayload>;

export type CwfActiveDocumentByCarePlanResponse = CwfActiveDocumentByCarePlan;

export type CwfActiveDocumentByCarePlanError = ApiError<unknown>;

export type CreateCwfDocumentPayload = components['schemas']['DocumentInput'];

export type CreateCwfDocumentRequest = ApiRequest<CreateCwfDocumentPayload>;

export type CreateCwfDocumentResponse = components['schemas']['Document'];

export type CreateCwfDocumentError = ApiError<unknown>;
